import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { keyBy } from "lib/keyBy"
import { pick } from "lib/pick"
import { Box } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { formatTimeShort } from "lib/format-time"

export function SchedulePeriodProfile({ schedulePeriods, period }) {
    const { isPDF } = useBoundContext()
    const schedulePeriod = schedulePeriods[period.frequency]
    if (!schedulePeriod) return null
    const classifications = keyBy(schedulePeriod.measurements, pick("classification"))

    let icon
    let color
    if (classifications.Red) {
        icon = "bi:diamond-fill"
        color = "red"
    } else if (classifications.Pink) {
        icon = "fluent:triangle-32-filled"
        color = "hotpink"
    } else if (classifications.Amber) {
        icon = "fluent:circle-24-filled"
        color = "orange"
    } else if (classifications.Green) {
        icon = "fluent:triangle-down-12-filled"
        color = "green"
    }

    return (
        <Box
            sx={{
                ml: 0.5,
                fontSize: "0.8rem",
                ...(isPDF && { width: 80, maxWidth: 80, mr: 0.5, flexWrap: "wrap" }),
            }}
            display="flex"
            alignItems="center"
            data-cy={`schedule-period-profile-${schedulePeriod.frequency}`}
        >
            <Box mr={1} display="flex" justifyContent="flex-end">
                <Box mr={0.5} className={`${color} dot`}>
                    <Iconify icon={icon} sx={{ color }} />
                </Box>
                <Box
                    minWidth={16}
                    sx={{ ...(isPDF && { wordWrap: "break-word", whiteSpace: "normal", maxWidth: 70 }) }}
                >
                    {schedulePeriod.count}
                </Box>
            </Box>
            <Box
                sx={{
                    minWidth: 35,
                    fontSize: "0.7rem",
                    color: "text.secondary",
                    textAlign: "right",
                    ...(isPDF && { wordWrap: "break-word", whiteSpace: "normal", maxWidth: 70 }),
                }}
            >
                ({formatTimeShort(schedulePeriod.minutes)})
            </Box>
        </Box>
    )
}
